import { ButtonHTMLAttributes } from "react";
import "./Button.scss";

const ColorBorder: React.FC<ButtonHTMLAttributes<any>> = (props: any) => {
  const { children, ...rest } = props;
  return (
    <div {...rest} className="button color-border wrapper">
      <div className="content">{children}</div>
    </div>
  );
};

export default ColorBorder;
